import { render, staticRenderFns } from "./AitsCustomizedTest.vue?vue&type=template&id=31b86fd8&scoped=true&"
import script from "./AitsCustomizedTest.vue?vue&type=script&lang=js&"
export * from "./AitsCustomizedTest.vue?vue&type=script&lang=js&"
import style0 from "./AitsCustomizedTest.vue?vue&type=style&index=0&id=31b86fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b86fd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VDataTable,VIcon,VImg,VTextField,VTooltip})
